import { Box, Typography, Grid, Card, CardContent, SxProps, Theme } from "@mui/material";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";

export const TeamComposition = () => {
  return (
    <SectionContainer sx={{ background: "#F8F9FA" }}>
      <SectionTitle>専業人材と副業人材の特性比較</SectionTitle>

      <Grid container spacing={4} sx={gridSx}>
        <Grid item xs={12} md={6}>
          <Card sx={fullTimeCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                専業人材の特徴
              </Typography>
              <Box sx={featureListSx}>
                <Typography variant="body1" sx={featureSx}>
                  • 日中帯のコミュニケーションが容易
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 平日日中の安定した稼働が可能
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 0.5〜1.0人月の充実した稼働時間
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 自社正社員またはフリーランス契約
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 安定したパフォーマンスを発揮
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={partTimeCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h3" sx={cardTitleSx}>
                副業人材の特徴
              </Typography>
              <Box sx={featureListSx}>
                <Typography variant="body1" sx={featureSx}>
                  • 日中帯のコミュニケーションに制約あり
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 早朝・深夜・土日などの稼働が中心
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 0.1〜0.5人月の限定的な稼働時間
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 他社正社員の副業またはフリーランス
                </Typography>
                <Typography variant="body1" sx={featureSx}>
                  • 高スキルながらコストパフォーマンスに優れる
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Typography variant="h3" sx={subtitleSx}>
        副業人材と専業人材を組み合わせた開発チーム
      </Typography>

      <Typography variant="body1" sx={descriptionSx}>
        副業人材のデメリットは専業人材がカバーすることで、副業人材のメリットだけを最大限に活用できます。
      </Typography>

      <Grid container spacing={4} sx={gridSx}>
        <Grid item xs={12} md={4}>
          <Card sx={benefitCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h4" sx={benefitTitleSx}>
                日中の対応
              </Typography>
              <Typography variant="body1" sx={benefitDescriptionSx}>
                日中の対応や緊急時の対応は専業人材が担当します。
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={benefitCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h4" sx={benefitTitleSx}>
                技術的な深掘り
              </Typography>
              <Typography variant="body1" sx={benefitDescriptionSx}>
                技術的な深掘りや並行開発は副業人材が担当します。
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={benefitCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h4" sx={benefitTitleSx}>
                365日サポート
              </Typography>
              <Typography variant="body1" sx={benefitDescriptionSx}>
                夜間や土日は副業人材が対応を行えば、365日運用するサービスでも365日サポートが可能です。
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Typography variant="h3" sx={subtitleSx}>
        開発チーム案
      </Typography>

      <Grid container spacing={4} sx={gridSx}>
        <Grid item xs={12} md={4}>
          <Card sx={teamCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h4" sx={teamTitleSx}>
                システム開発
              </Typography>
              <Box sx={teamDetailsSx}>
                <Typography variant="body1" sx={teamSubtitleSx}>
                  専業人材：
                </Typography>
                <Typography variant="body2" sx={teamMemberSx}>
                  • PM(1人月)
                  <br />
                  • EM(0.5人月)
                  <br />• デザイナー(0.5人月)
                </Typography>
                <Typography variant="body1" sx={teamSubtitleSx}>
                  副業人材：
                </Typography>
                <Typography variant="body2" sx={teamMemberSx}>
                  • バックエンド(0.1人月×10人)
                  <br />• フロント(0.1人月×15人)
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={teamCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h4" sx={teamTitleSx}>
                追加開発・保守運用
              </Typography>
              <Box sx={teamDetailsSx}>
                <Typography variant="body1" sx={teamSubtitleSx}>
                  専業人材：
                </Typography>
                <Typography variant="body2" sx={teamMemberSx}>
                  • PM(0.4人月)
                  <br />• EM(0.1人月)
                </Typography>
                <Typography variant="body1" sx={teamSubtitleSx}>
                  副業人材：
                </Typography>
                <Typography variant="body2" sx={teamMemberSx}>
                  • デザイナー(0.1人月×1人)
                  <br />• エンジニア(0.1人月×4人)
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={teamCardSx}>
            <CardContent sx={cardContentSx}>
              <Typography variant="h4" sx={teamTitleSx}>
                新規機能検証・調査
              </Typography>
              <Box sx={teamDetailsSx}>
                <Typography variant="body1" sx={teamSubtitleSx}>
                  専業人材：
                </Typography>
                <Typography variant="body2" sx={teamMemberSx}>
                  • PM(0.8人月)
                  <br />
                  • EM(0.3人月)
                  <br />• アプリ(0.5人月)
                </Typography>
                <Typography variant="body1" sx={teamSubtitleSx}>
                  副業人材：
                </Typography>
                <Typography variant="body2" sx={teamMemberSx}>
                  • アプリ(0.1人月×4人)
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const subtitleSx: SxProps<Theme> = (theme) => ({
  textAlign: "center",
  fontSize: "24px",
  fontWeight: 600,
  marginTop: "28px",
  marginBottom: "8px",
  color: "#333333",
});

const descriptionSx: SxProps<Theme> = {
  textAlign: "center",
  color: "#666666",
  maxWidth: "800px",
  marginLeft: "auto",
  marginRight: "auto",
};

const gridSx: SxProps<Theme> = {
  justifyContent: "center",
};

const fullTimeCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "none",
  borderRadius: "12px",
  backgroundColor: "#E3F2FD",
});

const partTimeCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "none",
  borderRadius: "12px",
  backgroundColor: "#F3E5F5",
});

const cardContentSx: SxProps<Theme> = {
  padding: "32px",
};

const cardTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "24px",
  fontWeight: 600,
  marginBottom: "24px",
  color: "#333333",
  textAlign: "center",
});

const featureListSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
};

const featureSx: SxProps<Theme> = {
  fontSize: "16px",
  lineHeight: 1.6,
  color: "#666666",
};

const benefitCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
  textAlign: "center",
});

const benefitTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "20px",
  fontWeight: 600,
  marginBottom: "16px",
  color: "#22A1B9",
});

const benefitDescriptionSx: SxProps<Theme> = {
  fontSize: "16px",
  lineHeight: 1.6,
  color: "#666666",
  textAlign: "left",
};

const teamCardSx: SxProps<Theme> = (theme) => ({
  height: "100%",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  borderRadius: "12px",
  backgroundColor: "#FFFFFF",
});

const teamTitleSx: SxProps<Theme> = (theme) => ({
  fontSize: "20px",
  fontWeight: 600,
  marginBottom: "20px",
  color: "#333333",
  textAlign: "center",
});

const teamDetailsSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

const teamSubtitleSx: SxProps<Theme> = {
  fontSize: "16px",
  fontWeight: 600,
  color: "#22A1B9",
  marginTop: "12px",
};

const teamMemberSx: SxProps<Theme> = {
  fontSize: "14px",
  lineHeight: 1.5,
  color: "#666666",
  marginLeft: "16px",
};
